export default () => {
    let $header = document.querySelector('header.header');
    let headerHeight = $header.offsetHeight;
    if ($('body').hasClass('page-template-page-search-results-php')) {
        $('body').css('padding-top', 0 + 'px');
        return;
    }

    // When the user is logged into CMS, the admin bar is added to the header height so we need to remove it in
    // order for the styling on the page to be correct
    const wpAdminBar = jQuery('#wpadminbar');

    if (wpAdminBar.length) {
        headerHeight = headerHeight - wpAdminBar.outerHeight();
    }

    // Add the header height as padding to the body
    document.body.style.paddingTop = headerHeight + 'px';

    // Add class to header when scrolling
    window.addEventListener('scroll', () => {
        if (window.scrollY > 165) {
            $header.classList.add('scrolled');
        } else {
            $header.classList.remove('scrolled');
        }
    });
}
